// Control IDs for the Viz App page (sai's viz-app IDs, mapped to ours by
// toTrapezium: viz-app.* -> product.viz-app.*). Its part rows and Next come
// from sai/ids.js.
import { toTrapezium as t } from './sai/trapezium';

export const IDS = {
  view: (key) => t(`viz-app.view-${key}`), // the app's two views above the rows: overview | smart (aria-pressed)
  showLive: t('viz-app.show-live'), // swaps the live Viz App into the phone, and back (aria-pressed)
  openLive: t('viz-app.open-live'), // opens the live Viz App in a new tab (external site)
  showcaseSound: t('viz-app.showcase-sound'), // the showcase video above the screens: sound on / off
  showcasePlay: t('viz-app.showcase-play'), // play / pause for that video
};
